export const enum GuestAPI {
  VERSION_1_0 = '1.0',
  VERSION_1_1 = '1.1',
  VERSION_1_3 = '1.3'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/RateRuleParameters/GuestAPI.ts